/* eslint-disable react/no-multi-comp */
import type { TypographyProps } from '@mui/material';
import { Typography } from '@mui/material';

export function SceneTitleLarge({
  children,
}: Pick<TypographyProps, 'children'>): React.ReactElement {
  return (
    <Typography
      color="text.dark"
      sx={{
        '+ .MuiTypography-paragraphBodyM': {
          mt: 2,
        },
        '+ .MuiTypography-subHeadingM': {
          mt: 1,
        },
      }}
      variant="headingL"
    >
      {children}
    </Typography>
  );
}

export function SceneTitleMedium({
  children,
}: Pick<TypographyProps, 'children'>): React.ReactElement {
  return (
    <Typography
      color="text.dark"
      sx={{
        '+ .MuiTypography-paragraphBodyM': {
          mt: 1,
        },
      }}
      variant="subHeadingL"
    >
      {children}
    </Typography>
  );
}
export function SceneSubTitle({ children }: Pick<TypographyProps, 'children'>): React.ReactElement {
  return (
    <Typography
      color="text.light"
      component="h3"
      sx={{
        '+ .MuiTypography-paragraphBodyM': {
          mt: 1,
        },
      }}
      variant="subHeadingM"
    >
      {children}
    </Typography>
  );
}

type PpSceneParagraph = Pick<TypographyProps, 'children' | 'paragraph'>;
export function SceneParagraph({ children, paragraph }: PpSceneParagraph): React.ReactElement {
  return (
    <Typography
      color="text.light"
      paragraph={paragraph}
      sx={{
        '+ .MuiTypography-paragraphBodyM': {
          mt: 2,
        },
      }}
      variant="paragraphBodyM"
    >
      {children}
    </Typography>
  );
}
